import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Secure your npm account with a strong and unique password using a password manager.`}</p>
    <p>{`You must choose or generate a password for your npm account that:`}</p>
    <ul>
      <li parentName="ul">{`is longer than 10 characters`}</li>
      <li parentName="ul">{`does not match or significantly contain your username, e.g. do not use 'username123'`}</li>
      <li parentName="ul">{`is not a `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/signup/common-passwords"
        }}>{`commonly used password`}</a></li>
      <li parentName="ul">{`has not been compromised and known to the `}<a parentName="li" {...{
          "href": "https://haveibeenpwned.com/"
        }}>{`Have I Been Pwned`}</a>{` breach database`}</li>
    </ul>
    <p>{`To keep your account secure, we recommend you follow these best practices:`}</p>
    <ul>
      <li parentName="ul">{`Use a password manager, such as `}<a parentName="li" {...{
          "href": "https://lastpass.com/"
        }}>{`LastPass`}</a>{` or `}<a parentName="li" {...{
          "href": "https://1password.com/"
        }}>{`1Password`}</a>{`, to generate a password more than 16 characters.`}</li>
      <li parentName="ul">{`Generate a unique password for npm. If you use your npm password elsewhere and that service is compromised, then attackers or other malicious actors could use that information to access your npm account.`}</li>
      <li parentName="ul">{`Configure two-factor authentication for your account. For more information, see "About two-factor authentication."`}</li>
      <li parentName="ul">{`Never share your password, even with a potential collaborator. Each person should use their own personal account on npm. For more information on ways to collaborate, see: "`}<a parentName="li" {...{
          "href": "/organizations"
        }}>{`npm organizations`}</a>{`".`}</li>
    </ul>
    <p>{`When you type a password to sign in, create an account, or change your password, npm will check if the password you entered is considered weak according to datasets like HaveIBeenPwned. The password may be identified as weak even if you have never used that password before.`}</p>
    <p>{`npm only inspects the password at the time you type it, and never stores the password you entered in plaintext. For more information, see `}<a parentName="p" {...{
        "href": "https://haveibeenpwned.com/"
      }}>{`HaveIBeenPwned`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      